import { put, takeEvery } from 'redux-saga/effects';
import { MigrateAction, MigrateActionTypes, MigrateActions } from '../actions/MigrateActions';
import { IAvailableArchitectureType } from '../../models/MigrateModels';

export function* getArchitecturesWorker(action: MigrateAction) {
  try {
    // ToDo: Make API Call
    // const response: responseType = (yield service.getUser())!;
    const response = action.data
    yield put(MigrateActions.setArchitecturesSuccess(response as IAvailableArchitectureType[]));
  } catch (error) {
    if (error instanceof Error) {
      yield put(MigrateActions.setArchitecturesError(error));
    }
  }
}

export function* migrateWatcher() {
  yield takeEvery(MigrateActionTypes.SET_ARCHITECTURES_START, getArchitecturesWorker);
}
